exports = module.exports = require("../node_modules/_css-loader@0.28.7@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#_magnifier_layer{position:absolute;z-index:9999;background:#f9f9f9}._magnifier{position:relative;display:inline-block}._magnifier img{vertical-align:middle}._magnifier_zoom{position:absolute;top:0;left:0;z-index:10;pointer-events:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.7@css-loader?minimize!./node_modules/_vue-loader@13.5.0@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-11907a96","scoped":false,"hasInlineConfig":false}!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=styles&index=0!./src/imgZoom.vue
// module id = 16
// module chunks = 0